<doc>
  @desc:   布局 - 比分列表组件
  @author:  
</doc>
<template>
  <div>
    <el-skeleton animated v-if="logdingFlag()">
      <template slot="template">
        <div class="live-sketleton-event">
          <template  v-for="(item, index) in [[1],[1,2],[1,2,3],[1,2,3,4],[1,2,3,4,5]]">
            <div class="live-sketleton-header" :key="'skh-' + index">
              <el-skeleton-item variant="text" class="sketleton-title" />
            </div>
            <div class="live-sketleton-match-box" :key="'skm-' + index">
              <div class="live-sketleton-match-item" v-for="(val, i) in item"  :key="'skmt-' + i">
                <div class="live-sketleton-stage">
                  <el-skeleton-item variant="text" class="sketleton-title" />
                </div>
                <div class="live-sketleton-home">
                  <el-skeleton-item variant="text" class="sketleton-title" />
                </div>
                <div class="live-sketleton-away">
                  <el-skeleton-item variant="text" class="sketleton-title" />
                </div>
                <div class="live-sketleton-analysis">
                  <el-skeleton-item variant="text" class="sketleton-title" />
                </div>
                <div class="live-sketleton-fav">
                  <el-skeleton-item variant="text" class="sketleton-title" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </el-skeleton>
      <!-- <div class="live-loading" v-if="logdingFlag()">
        <van-loading vertical>{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</van-loading>
      </div> -->
      <div class="live-event" v-if="liveData.LeagueList.length>0 && stateMatchNum[liveData.tabId]>0">
        <template v-for="(value, key) in visibleList">
          <template v-if="value['matches'].length>0">
            <div class="live-table-header" :class="expandFn(key) ? '' : 'live-table-header-hide'" @click="changeExpand(key)" v-if="leagueShow(value['matches'])" :key="'league' + key">
              <div class="fav-box flex flex-align-center">
                <button type="button" class="icon-font event-fav" :class="isFavLeagueState(value.leagueId)" @click.stop="followLeague($event,value.leagueId)"></button>
              </div>
              <div class="league-box flex flex-align-center">
                <img class="league-flag" :src="common.noCountryBack(liveData.FootballList['league'][value.leagueId], 'img')" @error="common.imgError($event, 'country')" />
                <span :gradeid="liveData.FootballList['league'][value.leagueId]['grade']" class="league-title">
                  <router-link :to="toLeague(value.leagueId)" :class="liveData.FootballList['league'][value.leagueId]['hasDt'] ? '' : 'league-title-hover'">
                    {{ common.noCountryBack(liveData.FootballList['league'][value.leagueId], 'name') + leagueName(key, liveData.FootballList['league'][value.leagueId]) }}
                  </router-link>
                </span>
              </div>
              <div class="match-display-box flex flex-align-center" v-if="!expandFn(key)">
                <span class="display-match-title">{{ langConfig.index[langConfig.curLang]['DISPLAY_MATCHES'] }}</span>
                <i class="display-live-match-count" v-if="disMatchTotal(key, 'live')">{{ disMatchTotal(key, 'live') }}</i>
                <i class="display-match-count">{{ disMatchTotal(key, 'totle') }}</i>
              </div>
              <div class="standing-box flex flex-align-center" v-if="liveData.FootballList['league'][value.leagueId]['hasStanding'] && expandFn(key)">
                <router-link :to="'/leagues/'+ value.leagueId +'/1'">
                  <i class="stading-icon icon-font icon-standing"></i>
                  <span>{{ langConfig.index[langConfig.curLang]['STANDING'] }}</span>
                </router-link>
              </div>
              <!-- <div class="odds-1-title" v-if="liveData.tabId==2 && oddsType==1 && liveData.isExpanded[key]['isExpanded']">1</div>
              <div class="odds-1-title" v-if="liveData.tabId==2 && oddsType==1 && liveData.isExpanded[key]['isExpanded']">X</div>
              <div class="odds-1-title marginRight30" v-if="liveData.tabId==2 && oddsType==1 && liveData.isExpanded[key]['isExpanded']">2</div>
              <div class="odds-1-title" v-if="liveData.tabId==2 && oddsType==2 && liveData.isExpanded[key]['isExpanded']">1</div>
              <div class="odds-1-title marginRight30" v-if="liveData.tabId==2 && oddsType==2 && liveData.isExpanded[key]['isExpanded']">2</div>
              <div class="odds-1-title" v-if="liveData.tabId==2 && oddsType==3 && liveData.isExpanded[key]['isExpanded']">O</div>
              <div class="odds-1-title marginRight70" v-if="liveData.tabId==2 && oddsType==3 && liveData.isExpanded[key]['isExpanded']">U</div> -->
              <div class="expanderBlock flex flex-align-center">
                <i class="expander-icon icon-font icon-arr" :class="expandFn(key) ? '' : 'expander-close'" @click.stop="changeExpand(key)"></i>
              </div>
            </div>
            <template v-if="expandFn(key) && Object.keys(liveData.FootballMatch).length > 0">
              <template v-for="(item, index) in value['matches']">
                <div class="live-match-box" v-if="stateFn(liveData.FootballMatch[item])" :key="'match_' + key + '_' + index">
                  <router-link :to="toDetails(liveData.FootballMatch[item])">
                  <div :class="matchesClassFn(item)" v-if="liveData.FootballMatch[item]['state']">
                    <div class="live-stage">
                      <span class="live-stage-block" :id="'live_'+ liveData.FootballMatch[item]['matchId']" :leagueId = "'league_' + liveData.FootballMatch[item]['leagueId']" v-html="gameTime(liveData.FootballMatch[item], svrTimestamp)"></span>
                      <div class="live-stage-mobli">
                        <div class="live-ht" v-if="mobileHtCshow(item, 'ht')">HT 
                          <span class="live-ht-part-home" v-if="isItem(item, 'homeLive') && isItem(item, 'homeLive', 'scoreHalf')">{{ liveData.FootballMatch[item]['homeLive']['scoreHalf'] }}</span> : 
                          <span class="live-ht-part-away" v-if="isItem(item, 'awayLive') && isItem(item, 'awayLive', 'scoreHalf')">{{ liveData.FootballMatch[item]['awayLive']['scoreHalf'] }}</span>
                        </div>
                        <div class="live-corner-mobile" v-if="mobileHtCshow(item, 'corner')">
                          <span class="live-corner-icon-mobile"><img class="corner-icon" src="~@/assets/images/corner-icon.svg" alt="SVG Image" /></span>
                          <span v-if="isItem(item, 'homeLive') && isItem(item, 'homeLive', 'corner')">{{ liveData.FootballMatch[item]['homeLive']['corner'] }}</span> - 
                          <span v-if="isItem(item, 'awayLive') && isItem(item, 'awayLive', 'corner')">{{ liveData.FootballMatch[item]['awayLive']['corner'] }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="live-logo-home"><img :src="common.teamImgGet(liveData.FootballMatch[item]['homeTeam']['id'])" @error="common.imgError($event, 'team')" /></div>
                    <div class="team-name-home" :class="dynClassStateFn('score', item, 'home', 'scoreFull')">{{ liveData.FootballMatch[item]['homeTeam']['fullName'] }}<i class="redCard-icon" v-if="isItem(item, 'homeLive') && isItem(item, 'homeLive', 'redCard')">{{ liveData.FootballMatch[item]['homeLive']['redCard'] }}</i></div>
                    <div class="live-logo-away"><img :src="common.teamImgGet(liveData.FootballMatch[item]['awayTeam']['id'])" @error="common.imgError($event, 'team')" /></div>
                    <div class="team-name-away" :class="dynClassStateFn('score', item, 'away', 'scoreFull')">{{ liveData.FootballMatch[item]['awayTeam']['fullName'] }}<i class="redCard-icon" v-if="isItem(item, 'awayLive') && isItem(item, 'awayLive', 'redCard')">{{ liveData.FootballMatch[item]['awayLive']['redCard'] }}</i></div>
                    <div class="live-score-home" :class="dynClassStateFn('score', item, 'home', 'scoreFull')">{{ scoreCallFn(item, 'homeLive', 'scoreFull') }}</div>
                    <div class="live-score-away" :class="dynClassStateFn('score', item, 'away', 'scoreFull')">{{ scoreCallFn(item, 'awayLive', 'scoreFull') }}</div>
                    <div class="live-part-home" v-if="isItem(item, 'homeLive') && isItem(item, 'homeLive', 'scoreHalf')">{{ scoreCallFn(item, 'homeLive', 'scoreHalf') }}</div>
                    <div class="live-part-away" v-if="isItem(item, 'awayLive') && isItem(item, 'awayLive', 'scoreHalf')">{{ scoreCallFn(item, 'awayLive', 'scoreHalf') }}</div>
                    <div class="live-corner-home" v-if="isItem(item, 'homeLive') && isItem(item, 'homeLive', 'corner')">
                      <img class="corner-icon" src="~@/assets/images/corner-icon.svg" alt="SVG Image" />
                      <span>{{ liveData.FootballMatch[item]['homeLive']['corner'] }}</span>
                    </div>
                    <div class="live-corner-away" v-if="isItem(item, 'awayLive') && isItem(item, 'awayLive', 'corner')">
                      <img class="corner-icon" src="~@/assets/images/corner-icon.svg" alt="SVG Image" />
                      <span>{{ liveData.FootballMatch[item]['awayLive']['corner'] }}</span>
                    </div>
                    <div class="live-lineup" v-if="liveData.FootballMatch[item]['hasLineup']==1">
                      <router-link :to="toLineUps(liveData.FootballMatch[item])">
                        <el-tooltip class="item" effect="dark" :content="langConfig.index[langConfig.curLang]['LINEUP_POST']" placement="bottom-end">
                          <img class="lineup-icon" :src="require(`@/assets/images/lineup-icon${theme == 5 ?'-5':''}.svg`)" alt="SVG Image" />
                        </el-tooltip> 
                      </router-link>
                    </div>
                    <!-- <div class="live-report" v-if="liveData.tabId!=2 && liveData.FootballMatch[item]['hasPrediction']">
                      <router-link :to="toPrediction(liveData.FootballMatch[item])">
                        <el-tooltip class="item" effect="dark" :content="langConfig.index[langConfig.curLang]['TIPS_PRO']" placement="bottom-end">
                          <img class="report-icon" src="~@/assets/images/report-icon.svg" alt="SVG Image" />
                        </el-tooltip>
                      </router-link>
                    </div> -->
                    <div class="live-odds" v-if="liveData.oddsTypeArr.length>0">
                      <el-popover
                        placement="bottom-end"
                        width="446"
                        trigger="hover"
                        :open-delay="300"
                        :disabled="oddsPoperShowFn(item)"
                        v-if="oddsShowFn(item)"
                        >
                        <div class="live-odds-popover">
                          <div class="live-odds-popover-title">
                            <span>{{ liveData.FootballMatch[item]['homeTeam']['fullName'] }}</span>
                            VS
                            <span>{{ liveData.FootballMatch[item]['awayTeam']['fullName'] }}</span>
                          </div>
                          <div class="live-odds-popover-content">
                            <table class="live-odds-popover-table">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th colspan="3" class="bgColor-FAFAFA">{{ langConfig.details[langConfig.curLang]['ODDS']['INITIAL_ODDS'] }}</th>
                                  <th colspan="3" class="bgColor-F0F0F0">{{ langConfig.details[langConfig.curLang]['ODDS']['LIVE_ODDS'] }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(oddsItem, oddsIndex) in oddTypeArr" :key="'oddsIndex_' + oddsIndex">
                                  <td class="bgColor-F0F0F0">{{ oddsItem.name }}</td>
                                  <td>{{ oddsCallFn(item, 'odds_'+oddsItem.id, oddsFieldFn(oddsItem.id, 'homeInit')) }}</td>
                                  <td>{{ oddsCallFn(item, 'odds_'+oddsItem.id, oddsFieldFn(oddsItem.id, 'drawInit')) }}</td>
                                  <td>{{ oddsCallFn(item, 'odds_'+oddsItem.id, oddsFieldFn(oddsItem.id, 'awayInit')) }}</td>
                                  <td :class="[dynClassStateFn('odds_'+oddsItem.id, item, null, oddsFieldFn(oddsItem.id, 'home'), 1)]">{{ oddsCallFn(item, 'odds_'+oddsItem.id, oddsFieldFn(oddsItem.id, 'home')) }}</td>
                                  <td :class="[dynClassStateFn('odds_'+oddsItem.id, item, null, oddsFieldFn(oddsItem.id, 'draw'), 1)]">{{ oddsCallFn(item, 'odds_'+oddsItem.id, oddsFieldFn(oddsItem.id, 'draw')) }}</td>
                                  <td :class="[dynClassStateFn('odds_'+oddsItem.id, item, null, oddsFieldFn(oddsItem.id, 'away'), 1)]">{{ oddsCallFn(item, 'odds_'+oddsItem.id, oddsFieldFn(oddsItem.id, 'away')) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <router-link :to="toOdds(liveData.FootballMatch[item])"  slot="reference">
                          <div class="live-odds-2" v-if="liveData.oddsTypeArr.includes(2)">
                            <span :class="[dynClassStateFn('odds_2', item, null, 'home', 1)]">{{ oddsCallFn(item, 'odds_2', 'home') }}</span>
                            <span :class="[dynClassStateFn('odds_2', item, null, 'hand', 1)]">{{ oddsCallFn(item, 'odds_2', 'hand', 'home') }}</span>
                            <span :class="[dynClassStateFn('odds_2', item, null, 'away', 1)]">{{ oddsCallFn(item, 'odds_2', 'away') }}</span>
                          </div>
                          <div class="live-odds-3" v-if="liveData.oddsTypeArr.includes(3)">
                            <span :class="dynClassStateFn('odds_3', item, null, 'over', 1)">{{ oddsCallFn(item, 'odds_3', 'over') }}</span>
                            <span :class="dynClassStateFn('odds_3', item, null, 'total', 1)">{{ oddsCallFn(item, 'odds_3', 'total') }}</span>
                            <span :class="dynClassStateFn('odds_3', item, null, 'under', 1)">{{ oddsCallFn(item, 'odds_3', 'under') }}</span>
                          </div>
                          <div class="live-odds-1" v-if="liveData.oddsTypeArr.includes(1)">
                            <span :class="[dynClassStateFn('odds_1', item, null, 'home', 1)]">{{ oddsCallFn(item, 'odds_1', 'home') }}</span>
                            <span :class="[dynClassStateFn('odds_1', item, null, 'draw', 1)]">{{ oddsCallFn(item, 'odds_1', 'draw') }}</span>
                            <span :class="[dynClassStateFn('odds_1', item, null, 'away', 1)]">{{ oddsCallFn(item, 'odds_1', 'away') }}</span>
                          </div>
                        </router-link>
                      </el-popover>
                    </div>
                    
                    
                    <div class="live-odds-mobli" v-if="liveData.oddsType==1">
                      <router-link :to="toOdds(liveData.FootballMatch[item])">
                        <span :class="dynClassStateFn('odds_1', item, null, 'home', 2)">{{ oddsCallFn(item, 'odds_1', 'home') }}</span>
                        <span :class="dynClassStateFn('odds_1', item, null, 'draw', 2)">{{ oddsCallFn(item, 'odds_1', 'draw') }}</span>
                        <span :class="dynClassStateFn('odds_1', item, null, 'away', 2)">{{ oddsCallFn(item, 'odds_1', 'away') }}</span>
                      </router-link>
                    </div>

                    <div class="live-odds-mobli" v-if="liveData.oddsType==2">
                      <router-link :to="toOdds(liveData.FootballMatch[item])">
                        <span :class="dynClassStateFn('odds_2', item, null, 'home', 2)">{{ oddsCallFn(item, 'odds_2', 'home') }}</span>
                        <span :class="dynClassStateFn('odds_2', item, null, 'hand', 2)">{{ oddsCallFn(item, 'odds_2', 'hand') }}</span>
                        <span :class="dynClassStateFn('odds_2', item, null, 'away', 2)">{{ oddsCallFn(item, 'odds_2', 'away') }}</span>
                      </router-link>
                    </div>

                    <div class="live-odds-mobli" v-if="liveData.oddsType==3">
                      <router-link :to="toOdds(liveData.FootballMatch[item])">
                        <span :class="dynClassStateFn('odds_3', item, null, 'over', 2)">{{ oddsCallFn(item, 'odds_3', 'over') }}</span>
                        <span :class="dynClassStateFn('odds_3', item, null, 'total', 2)">{{ oddsCallFn(item, 'odds_3', 'total') }}</span>
                        <span :class="dynClassStateFn('odds_3', item, null, 'under', 2)">{{ oddsCallFn(item, 'odds_3', 'under') }}</span>
                      </router-link>
                    </div>
                    
                    <div class="live-fav">
                      <button type="button" class="icon-font event-fav" :class="isFavMatchState(item)" @click.stop="followMatch($event,liveData.FootballMatch[item]['state'], item)"></button>
                    </div>
                  </div>
                </router-link>
                </div>
              </template>
            </template>
          </template>
          <template v-if="ListAd.length>0 && key == 0">
            <template v-for="(item, index) in ListAd">
              <div class="ad-box" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 106" :key="index">
                <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="screenWidth>767 ? item.img : item.imgMobile" /></router-link>
              </div>
            </template>
          </template>
        </template >
      </div>
      <div class="noData" v-if="stateMatchNum[liveData.tabId] == 0">
        <DefaultPic />
      </div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import { getAdHits } from '@/api/api';
  import DefaultPic from "@/components/defaultPic";

  export default {
    name: 'soccerList',
    props: {
      liveData: { //
        type: Object,
        default: () => {},
      },
      ListAd: {
        type: Array,
        default: () => [],
      }
    },

    components: {
      DefaultPic
    },

    data() {
      return {
        theme: 1,
        watchFlag: true,
        tabId: 0,
        //oddsType: 1, // 赔率类型
        //oddsForm: 1, // 赔率格式
        liveSate: [1,2,3,5,10,11,16], //比赛进行中
        unSate: [4,5,6,13,14,15], // 状态异常
        stateArr:[[],[1,2,3,5,10,11,16],[],[4],[17]],
        state2ND: [1,2,3,8,11], // 1上半场 ,2中场, 3下半场, 8加时中, 11点球
        svrTimestamp: 0,
        tsz: '+08:00',

        //FootballList: {},
        //FootballMatch: {}, // 全部比赛数据
        //FootballSortMatch: {}, // 排序后的数据
        //LeagueList: [], // 渲染数据
        follow: {},
        myLeague: [],

        oddsData:{}, // 指数类型列表数据
        dynState: {}, // 动态更新标识
          
        proceessTime: null, // 进程定时器
        proceessNum: false, // 进程

        emitObj:{
          svrTimestamp: 0,
          loginShow: false,
        },

        oddsDateDiff:{ //指数新旧存储
          odds_1:{},
          odds_2:{},
          odds_3:{},
        },

        stateMatchNum: {
          0: 1,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
        }, // 各状态比赛数

        screenWidth:2000,

        timeGap: 0, // 服务器时间与客户段时间差值
        oddTypeArr: [
          {
            id:2,
            name:'AH'
          },
          {
            id:3,
            name:'O/U'
          },
          {
            id:1,
            name:'1x2'
          },
        ],

        chunkSize: 20, // 每次加载的段落数量
        startIndex: 0, // 起始索引
        chunkTimeOut: null
      }
    },

    computed: {
      //...mapState('home', ['FootballList', 'FootballSortMatch', 'LeagueList', 'FootballMatch', 'hotLeague']),
      // ws() {
      //   return socketServer.Instance
      // }

      visibleList() {
        //console.log('起始',this.startIndex)
        //console.log('总数',this.liveData.LeagueList.length)
        this.loadMoreItems();
        return this.liveData.LeagueList.slice(0, this.startIndex + this.chunkSize);
      }

    },

    mounted(){
      if(typeof(window) != 'undefined'){
        const host = window.location.host;
        if(host.indexOf('kqbd') != -1){
          this.theme = 5;
          
        }
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
      }
    },

    methods: {
      //...mapMutations('home', ['setFootballList', 'setFootballSortMatch', 'setLeagueList', 'setFootballMatch', 'setHotLeague']),

      // loading
      logdingFlag(){
        if(this.liveData.LeagueList.length == 0){
          return true;
        }

        return false;
      },

      loadMoreItems(){
        this.chunkTimeOut = setTimeout(() => {
          //console.log('最小',this.startIndex + this.chunkSize)
          let end = Math.min(this.startIndex + this.chunkSize, this.liveData.LeagueList.length);
          if(end < this.liveData.LeagueList.length){
            this.$nextTick(() => {
              this.startIndex += this.chunkSize; // 加载初始段落
            });
          }else{
            clearTimeout(this.chunkTimeOut);
          }
        }, 1000);
      },

      // 7天后
      after7dayFn(){
        let _svrtime = this.common.jsonParse(this.svrTimestamp);
        let today = new Date(_svrtime*1000);
        today.setDate(today.getDate() + 7);
        let after7day = this.common.dateStr(today.getTime()/1000, 'YYYYMMddHHmm');

        return after7day;
      },

      //状态判断
      stateFn(val){
        let _tabId = this.liveData.tabId, _val = val, _state=[];
        if(_tabId == 1 || _tabId == 3 || _tabId == 4){
          _state = this.stateArr[_tabId];
          if(_state.includes(_val.state)){
            return true;
          }else{
            return false;
          }    
        }
        return true;
      },

      //赛事列表class返回
      matchesClassFn(id){
        let _id = id, _FootballMatch = this.liveData.FootballMatch, _liveSate = this.liveSate, _state = _FootballMatch[_id]['state'], _oddsType = this.liveData.oddsType, _oddsTypeArr = this.liveData.oddsTypeArr;
        let _class = 'live-match-item';
        let _homeScore = this.dynClassStateFn('score', _id, 'home', 'scoreFull'),
            _awayScore = this.dynClassStateFn('score', _id, 'away', 'scoreFull');

        if(_liveSate.includes(_state)){ //比赛进行中
          _class += ' live-match-stage';
        }

        if(_homeScore != ''){ //主队比分更新
          _class += ' ' + _homeScore;
        }

        if(_awayScore != ''){ //客队比分更新
          _class += ' ' + _awayScore;
        }

        if(this.screenWidth>767){//PC
          if(_oddsTypeArr.length == 0){//无选择指数类型
            _class += ' live-match-item-no-odds';
          }else{
            _class += '';
          }
        }else{//webapp
          if(_oddsType == 4){//无选择指数类型
            _class += ' live-match-item-no-odds';
          }else{
            _class += '';
          }
        }

        return _class;
      },

      //联赛条显示
      leagueShow(val){
        let _val = val, _tabId = this.liveData.tabId, _state=[], _FootballMatch = this.liveData.FootballMatch, _num=0;
        if(_tabId == 1 || _tabId == 3 || _tabId == 4){
          _state = this.stateArr[_tabId];
          for(let i=0; i<_val.length; i++){
            if(_state.includes(_FootballMatch[_val[i]]['state'])){
              _num++;
            }
          }
          if(_num > 0){
            return true;
          }else{
            return false;
          }
        }

        return true;
      },

      // 各状态比赛数统计
      stateMatchNumFn(){
        let _leagueList = this.liveData.LeagueList, _FootballMatch = this.liveData.FootballMatch, _tabId = this.liveData.tabId, _state = this.stateArr[_tabId];
        //console.log('比赛数', _leagueList)
        this.stateMatchNum = {
          0: 1,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
        };

        for(let i=0; i<_leagueList.length; i++){
          let _leagueItme = _leagueList[i];
          let _matches = _leagueItme['matches'];
          for(let j=0; j<_matches.length; j++){
            if(_tabId != 2 && _tabId != 0){
              if(_state.includes(_FootballMatch[_matches[j]]['state'])){
                this.stateMatchNum[_tabId]++;
              }
            }else{
              this.stateMatchNum[_tabId]++;
            }
          }
        }

        //console.log('比赛数', this.stateMatchNum)
      },

      // 联赛名
      leagueName(key, val){
        let _key = key, _val = val;

        if(this.screenWidth>767){
          return _val['fullName']
        }else{
          return _val['shortName']
        }
      },

      expandFn(key){
        let _isExpanded = this.liveData.isExpanded;
        if(typeof(_isExpanded[key]) == 'undefined' || typeof(_isExpanded[key]['isExpanded']) == 'undefined'){
          if(typeof(_isExpanded[key]) == 'undefined'){
            this.liveData.isExpanded[key] = {
              'leagueId': key,
              'isExpanded': true
            }
          }else{
            this.liveData.isExpanded[key]['isExpanded'] = true;
          }
          return this.liveData.isExpanded[key]['isExpanded'];
        }

        return _isExpanded[key]['isExpanded'];
      },

      changeExpand(key){ // 展开收缩
        if(this.liveData.isExpanded[key]['isExpanded']){ // 收缩
          this.liveData.isExpanded[key]['isExpanded'] = false;
        }else{ // 展开
          this.liveData.isExpanded[key]['isExpanded'] = true;
        }
        //this.disMatchEvent(key);
      },

      // 获取比赛时间
      gameTime(val, svrtime){
        ////console.log('时间差', this.timeGap)
        let _val = val;
        let _tsz = this.tsz;
        let _start = _val['state'],
         _titme = this.common.getDateByArray(_tsz, _val['startTime']),
          _realtime = this.common.getDateByArray(_tsz, _val['startHalfTime']), 
          _injuryTime = _val['injuryTime'], 
          _svrtime = this.common.getDateByArray(_tsz, svrtime), 
          _nowtitme = this.common.getDateByArray(_tsz, Date.parse(new Date())/1000);
        let _timeOld = this.common.dateStr(_val['startTime'], 'YYYYMMdd');
        let _timeNews = this.common.dateStr(_titme, 'YYYYMMdd');
        if([17].indexOf(_start)>-1){//未开赛
          // let _date = '';
          // if(_timeOld != _timeNews){ // 跨日显示日期
          //   _date = this.common.dateStr(_titme, 'dd/MM') + '\n';
          // }
          return this.common.dateStr(_titme, 'HH:mm');
        }else if([1,3].indexOf(_start)>-1){//上下半场
          var bssj = 1;

          if(typeof(_realtime) != 'undefined' && typeof(_val['startHalfTime']) != 'undefined'){
            _titme = _realtime;
          }

          if(_start==1){
            bssj = parseInt((_nowtitme - _titme) / 60) + this.timeGap;
            if (bssj < 1){
              bssj = 1;
            }
            if (bssj > 45){
              bssj = 45;
            }
          }else{
            bssj = parseInt((_nowtitme - _titme) / 60) + 45 + this.timeGap;
            if (bssj < 46){
              bssj = 46;
            }
            if (bssj > 90){
              bssj = 90;
            }
          }
          
          if(typeof(_injuryTime) != 'undefined' && bssj == 90){
            bssj = "<em class=\"flickerBox\">90+'</em>";
          }else{
            bssj += "<em class=\"flickerBox\">'</em>";
          }
          
          return bssj;
        }else if([2,4,5,6,8,11,13,14,15].indexOf(_start)>-1){//其它状态
          return this.langConfig.txtLang[this.langConfig.curLang]['STATE_ARR'][_start];
        }
        return "";
      },

      // 跳转内页
      toDetails(val){
        let _val = val, _matchId = _val['matchId'], _state = _val['state'], _stateArr = this.liveSate, _tab = 'live', _homeName = this.common.formalTitle(_val['homeTeam']['fullName']), _awayName = this.common.formalTitle(_val['awayTeam']['fullName']);

        if(!_stateArr.includes(_state) && _state*1 != 4){
          _tab = 'H2H';
        }

        //return '/details/' + _matchId + _tab;
        return `/details/${_matchId}/${_tab}/${_homeName}-vs-${_awayName}`;

        //this.$router.push('/details/' + _matchId + _tab);

      },

      // 跳转联赛
      toLeague(leagueId){
        let _leagueId = leagueId, _FootballList = this.liveData.FootballList, _hasDt = _FootballList['league'][_leagueId]['hasDt'];

        
        if(typeof(_hasDt) != 'undefined' && _hasDt){
          return '/leagues/' + _leagueId + '/2';
          //this.$router.push('/leagues/' + _leagueId + '/0');
        }else{
          return ''
        }
      },

      // 跳转阵容
      toLineUps(val){
        let _val = val, _matchId = _val['matchId'], _homeName = this.common.formalTitle(_val['homeTeam']['fullName']), _awayName = this.common.formalTitle(_val['awayTeam']['fullName']), _tab = 'lineUps';

        return `/details/${_matchId}/${_tab}/${_homeName}-vs-${_awayName}`;
        //this.$router.push('/details/' + matchId + '?tab=lineUps');
      },

      // 跳转推介
      toPrediction(val){
        let _val = val, _matchId = _val['matchId'], _homeName = this.common.formalTitle(_val['homeTeam']['fullName']), _awayName = this.common.formalTitle(_val['awayTeam']['fullName']), _tab = 'prediction';

        return `/details/${_matchId}/${_tab}/${_homeName}-vs-${_awayName}`;
        //this.$router.push('/details/' + matchId + '?tab=prediction');
      },

      // 跳转指数
      toOdds(val){
        let _val = val, _matchId = _val['matchId'], _homeName = this.common.formalTitle(_val['homeTeam']['fullName']), _awayName = this.common.formalTitle(_val['awayTeam']['fullName']), _tab = 'Odds';

        return `/details/${_matchId}/${_tab}/${_homeName}-vs-${_awayName}`;
        //this.$router.push('/details/' + matchId + '?tab=Odds');
      },

      // 比分返回
      scoreCallFn(key, team, type){
        let _data = this.liveData.FootballMatch, _state = _data[key]['state'], _key = key, _team = team, _type = type, _stateArr = [1,2,3,4,5,10,11,16];
        if(_state == 17){
          return '';
        }

        if(_stateArr.includes(_state) && typeof(_data[_key][_team][_type]) == 'undefined'){
          return 0;
        }

        let _score = 0;
        if(_type == 'scoreFull'){
          _score = _data[_key][_team][_type];
        }else if(_type == 'scoreHalf'){
          _score = '('+ _data[_key][_team][_type] +')';
        }

        return _score;
      },

      // 指数弹窗是否显示
      oddsPoperShowFn(key){
        let _key = key, _FootballMatch = this.liveData.FootballMatch, _state = _FootballMatch[_key].state, _unState = this.unSate;
        if(_unState.includes(_state)){
          return false;
        }

        return false;
      },

      // 指数显示
      oddsShowFn(key){
        let _key = key, _oddsData = this.liveData.oddsData;
        if(typeof(_oddsData['odds_1'][_key]) == 'undefined' && typeof(_oddsData['odds_2'][_key]) == 'undefined' && typeof(_oddsData['odds_3'][_key]) == 'undefined'){
          return false;
        }

        return true;
      },

      // 指数字段返回
      oddsFieldFn(id, type){
        let _id = id, _type = type;
        if(_type == 'homeInit'){
          if(_id == 3){
            _type = 'overInit';
          }
        }
        if(_type == 'drawInit'){
          if(_id == 2){
            _type = 'handInit';
          }
          if(_id == 3){
            _type = 'totalInit';
          }
        }
        if(_type == 'awayInit'){
          if(_id == 3){
            _type = 'underInit';
          }
        }
        if(_type == 'home'){
          if(_id == 3){
            _type = 'over';
          }
        }
        if(_type == 'draw'){
          if(_id == 2){
            _type = 'hand';
          }
          if(_id == 3){
            _type = 'total';
          }
        }
        if(_type == 'away'){
          if(_id == 3){
            _type = 'under';
          }
        }

        return _type;
      },

      // 指数返回
      oddsCallFn(key, oddstype, type, type2){
        let _key = key, _oddstype = oddstype, _oddsData = this.liveData.oddsData, _type = type, _type2 = type2;
        if(typeof(_oddsData[_oddstype][_key]) == 'undefined' || _oddsData[_oddstype][_key][_type] == 'undefined'){
          if(typeof(_oddsData['odds_1'][_key]) == 'undefined' && typeof(_oddsData['odds_2'][_key]) == 'undefined' && typeof(_oddsData['odds_3'][_key]) == 'undefined'){
            return ''
          }else{
            return '-'
          }
        }

        if(_type == 'hand'){
          if(_type2 == 'home'){
            return Number(_oddsData[_oddstype][_key][_type]);
          }else if(_type2 == 'away'){
            return -Number(_oddsData[_oddstype][_key][_type]);
          }
        }

        return this.oddsLuckyChange(_oddsData[_oddstype][_key][_type], _type, _oddstype);
      },

      // 赔率转换
      oddsLuckyChange(val, type2, oddstype){
        let _val = val, _form = this.liveData.oddsForm, _oddstype = oddstype, _type2 = type2;
        let _typeArr = ['home', 'away', 'over', 'under', 'homeInit', 'awayInit', 'overInit', 'underInit'];
        let _drawArr = ['hand', 'total', 'handInit', 'totalInit'];

        // if(_type == 1){
        //   return this.common.oddsFromChange(_val, _form);
        // }

        if(_oddstype == 'odds_2' || _oddstype == 'odds_3'){
          if(_typeArr.includes(_type2)){
            _val =  this.common.addValue(_val*1,1);
          }
        }
        if(_drawArr.includes(_type2)){
          return _val;
        }

        return this.common.oddsFromChange(_val, _form);
      },

      // 更新进程时间
      process_time: function () {
        if(this.proceessNum){
          if(this.watchFlag){
            this.watchFlag = false;
          }
          this.svrTimestamp += 60;
          this.emitObj.svrTimestamp = this.svrTimestamp;
          this.$emit('rechangList', this.emitObj);
        }else{
          this.proceessNum = true;
        }

        if (typeof(this.proceessTime) == "number"){
          clearTimeout(this.proceessTime);
        }
        this.proceessTime = setTimeout(this.process_time, 60000);
      },

      // 赛事隐藏统计
      disMatchTotal(key, type){ // key-联赛id
        let _key = key, _isExpanded = this.expandFn(_key), _tabId = this.liveData.tabId, _state = [], _type = type, _disMatch = {};
        if(_isExpanded == false){
          let _leagueTemp = [], _matchTemp = this.liveData.FootballMatch;

          _leagueTemp = this.liveData.LeagueList[key]['matches'];
          
          if(_tabId == 1 || _tabId == 3 || _tabId == 4){
            _disMatch[key] = {
              totle: 0,
              live: 0
            }
          }else{
            _disMatch[key] = {
              totle: _leagueTemp.length,
              live: 0
            }
          }
          

          for(let i=0; i<_leagueTemp.length; i++){
            if(_tabId == 1 || _tabId == 3 || _tabId == 4){
              _state = this.stateArr[_tabId];
              if(_tabId == 1){
                if(_state.includes(_matchTemp[_leagueTemp[i]].state)){ // 进行中
                  _disMatch[key].live++;
                  _disMatch[key].totle++;
                }
              }
              if(_tabId == 3 || _tabId == 4){
                if(_state.includes(_matchTemp[_leagueTemp[i]].state)){ // 完场/未开始
                  _disMatch[key].totle++;
                }
              }
            }else{
              if(this.liveSate.includes(_matchTemp[_leagueTemp[i]].state)){ // 进行中
                _disMatch[key].live++;
              }
            }
          }
        }else{
          _disMatch[key] = {
            totle: 0,
            live: 0
          }
        }

        if(_type == 'totle'){
          return _disMatch[key].totle;
        }

        if(_type == 'live'){
          return _disMatch[key].live;
        }
      },

      // 赛事隐藏统计
      disMatchEvent(key){ // key-联赛id
        let _key = key, _isExpanded = this.expandFn(_key), _tabId = this.liveData.tabId, _state = [];
        if(_isExpanded == false){
          let _leagueTemp = [], _matchTemp = this.liveData.FootballMatch;

          _leagueTemp = this.liveData.LeagueList[key]['matches'];
          
          if(_tabId == 1 || _tabId == 3){
            this.disMatch[key] = {
              totle: 0,
              live: 0
            }
          }else{
            this.disMatch[key] = {
              totle: _leagueTemp.length,
              live: 0
            }
          }
          

          for(let i=0; i<_leagueTemp.length; i++){
            if(_tabId == 1 || _tabId == 3){
              _state = this.stateArr[_tabId];
              if(_tabId == 1){
                if(_state.includes(_matchTemp[_leagueTemp[i]].state)){ // 进行中
                  this.disMatch[key].live++;
                  this.disMatch[key].totle++;
                }
              }
              if(_tabId == 3){
                if(_state.includes(_matchTemp[_leagueTemp[i]].state)){ // 完场
                  this.disMatch[key].totle++;
                }
              }
            }else{
              if(this.liveSate.includes(_matchTemp[_leagueTemp[i]].state)){ // 进行中
                this.disMatch[key].live++;
              }
            }
          }
        }else{
          this.disMatch[key] = {
            totle: 0,
            live: 0
          }
        }
      },

      // 是否有数据返回
      isItem(key, type1, type2){
        let _data= this.liveData.FootballMatch, _key = key, _type1 = type1, _type2 = type2;
        if(typeof(_data[_key][_type1]) == 'undefined'){
          return false;
        }
        if(typeof(_type2) != 'undefined' && typeof(_data[_key][_type1][_type2]) == 'undefined'){
          return false;
        }
        return true;
      },

      // 比分更新
      scoreUpdate(oldData, newData){
        //console.log('旧数据', JSON.parse(JSON.stringify(oldData)))
        //console.log('新数据', newData)
        var that = this;
        let _oldDate = oldData, _data = newData;
        let _oldHomeScore = ScoreFn(_oldDate, 'homeLive');
        let _oldAwayScore = ScoreFn(_oldDate, 'awayLive');
        let _newHomeScore = ScoreFn(_data, 'homeLive');
        let _newAwayScore = ScoreFn(_data, 'awayLive');

        setTimeFn(_oldHomeScore, _newHomeScore, _data.matchId, 'homeLive');
        setTimeFn(_oldAwayScore, _newAwayScore, _data.matchId, 'awayLive');

        function ScoreFn(res, type){
          let _score = 0, _res = res, _type = type;
          _score = _res?.[_type]?.scoreFull;
          return _score
        }

        function setTimeFn(score1, score2, matchId, type){
          let scoreTime = null;
          let _dynState = that.liveData.dynState;
          //console.log('比分更新',score1, score2, matchId, type)
          if(typeof(score1) == 'undefined'){
            score1 = 0;
          }
          if(typeof(score2) == 'undefined'){
            score2 = 0;
          }
          if(score1*1 != score2*1 && typeof(that.liveData.dynState[matchId]) != 'undefined'){
            that.liveData.dynState[matchId][type].scoreFull = true;
            //console.log('高亮', matchId, that.liveData.dynState[matchId][type].scoreFull)
            setTimeout(() => {
              that.liveData.dynState[matchId][type].scoreFull = false;
              //console.log('取消高亮', matchId, that.liveData.dynState[matchId][type].scoreFull)
            }, 8000);

            // if (typeof(scoreTime) == "number"){
            //   clearTimeout(scoreTime);
            // }
            // scoreTime = setTimeout(() => {
            //   _dynState[matchId][type].scoreFull = false;
            // }, 8000);
          }
        }
      },

      // 指数更新
      oddsUpdate(type, matchId, oldData, newData){
        var that = this;
        let _type = type, _matchId = matchId;
        let _oldDate = oldData, _newData = newData;
        let _home = '' , _away = '', _draw = '';

        if(_type*1 == 1){ //欧指
          _home = 'home';
          _away = 'away';
          _draw = 'draw';
        }

        if(_type*1 == 2){ //亚指
          _home = 'home';
          _away = 'away';
          _draw = 'hand';
        }

        if(_type*1 == 3){ //大小/总分
          _home = 'over';
          _away = 'under';
          _draw = 'total';
        }

        let _oldHome = OddsFn(_oldDate, _home);
        let _olddraw = OddsFn(_oldDate, _draw);
        let _oldAway = OddsFn(_oldDate, _away);
        let _newHome = OddsFn(_newData, _home);
        let _newdraw = OddsFn(_newData, _draw);
        let _newAway = OddsFn(_newData, _away);

        setTimeFn(_oldHome, _newHome, _matchId, _type, _home);
        setTimeFn(_olddraw, _newdraw, _matchId, _type, _draw);
        setTimeFn(_oldAway, _newAway, _matchId, _type, _away);

        function OddsFn(res, type){
          let _odds = 0, _res = res, _type = type;
          _odds = _res[_type];
          return _odds
        }

        function setTimeFn(odds1, odds2, matchId, type1, type2){
          let oddsTime = null;
          //console.log('旧指数数据', odds1)
          //console.log('新指数数据', odds2)
          let _dynState = that.liveData.dynState;
          let _oddsNum = 0;
          if(odds1 != odds2){ // 新旧指数数据比较

            //指数新旧存储
            let _oddsDataDiff = that.liveData.oddsDateDiff;
            if(typeof(_oddsDataDiff['odds_'+type1][matchId]) == 'undefined'){
              _oddsDataDiff['odds_'+type1][matchId] = {};
            }
            if(typeof(_oddsDataDiff['odds_'+type1][matchId][type2]) == 'undefined'){
              _oddsDataDiff['odds_'+type1][matchId][type2] = {};
            }

            _oddsDataDiff['odds_'+type1][matchId][type2]['old'] = odds1*1;
            _oddsDataDiff['odds_'+type1][matchId][type2]['new'] = odds2*1;

            that.liveData.oddsDateDiff = _oddsDataDiff;

            //console.log('指数存储',that.liveData.oddsDateDiff)

            if(typeof(_dynState[matchId]) == 'undefined'){
              return;
            }
            //console.log('指数变化标识', matchId, _dynState[matchId]['odds_'+type1][type2])
            if(odds2*1 == odds1*1){
              _oddsNum = 0;
            }
            if(odds2*1 > odds1*1){
              _oddsNum = 1;
            }
            if(odds2*1 < odds1*1){
              _oddsNum = 2;
            }
            that.liveData.dynState[matchId]['odds_'+type1][type2] = _oddsNum;

            // setTimeout(() => {
            //   that.liveData.dynState[matchId]['odds_'+type1][type2] = 0;
            // }, 10000);

            // if (typeof(oddsTime) == "number"){
            //   clearTimeout(oddsTime);
            // }
            // oddsTime = setTimeout(() => {
            //   _dynState[matchId]['odds_'+type1][type2] = false;
            // }, 10000);
          }
        }
      },

      // 指数更新tips
      oddsTipsShow(matchId, oddsType, type){
        let _matchId = matchId, _oddsType = oddsType, _type = type;
        let _oddsDataDiff = this.common.jsonParse(this.liveData.oddsDateDiff);

        if(typeof(_oddsDataDiff['odds_'+_oddsType][_matchId]) != 'undefined' && typeof(_oddsDataDiff['odds_'+_oddsType][_matchId][_type]) != 'undefined' && typeof(_oddsDataDiff['odds_'+_oddsType][_matchId][_type]['new']) != 'undefined'){
          return false;
        }
        
        return true;
      },

      // 指数更新tips文本
      oddsTipsTxt(matchId, oddsType, type){
        let _matchId = matchId, _oddsType = oddsType, _type = type;
        let _oddsDataDiff = this.common.jsonParse(this.liveData.oddsDateDiff);
        let _txt = '', _old = 0, _new = 0;
        let _form = this.liveData.oddsForm;

        if(typeof(_oddsDataDiff['odds_'+_oddsType][_matchId]) != 'undefined' && typeof(_oddsDataDiff['odds_'+_oddsType][_matchId][_type]) != 'undefined' && typeof(_oddsDataDiff['odds_'+_oddsType][_matchId][_type]['new']) != 'undefined'){
          _old = _oddsDataDiff['odds_'+_oddsType][_matchId][_type]['old'];
          _new = _oddsDataDiff['odds_'+_oddsType][_matchId][_type]['new'];

          if(oddsType == 2 || oddsType == 3){
            _old = this.common.addValue(_old*1, 1);
            _new = this.common.addValue(_new*1, 1);
          }
          _txt = this.common.oddsFromChange(_old, _form) + ' → ' + this.common.oddsFromChange(_new, _form);
        }

        return _txt;
      },

      // 状态返回
      // type- score:比分, odds:指数
      // id-比赛id
      // team-队伍
      // key-类型
      // plat-平台
      dynClassStateFn(type, id, team, key, plat){
        let _type = type, _id = id, _team = team, _key = key, _plat = plat, _class = '', _oddsType = this.liveData.oddsType, _dynState = this.liveData.dynState;
        if(_type == 'score'){
          _class = _dynState[_id][_team+'Live'][_key] ? 'live-red' : '';
        }

        if(_type == 'odds_1' || _type == 'odds_2' || _type == 'odds_3'){
          let _num = _dynState[_id][_type][key]*1;
          if(_num !=0 ){
              if(_num == 1){ // 升
                _class = 'green';
              }else{ // 降
                _class = 'red';
              }
            }
        }

        return _class;
      },

      // 联赛组关注是否显示
      isFavLeagueState(leagueId){
        let _leagueId = leagueId, _leagueList = this.myLeague, _className= '';

        if(typeof(_leagueList) != 'undefined' && _leagueList.length > 0){
          for(let i=0; i<_leagueList.length; i++){
            let _id = _leagueList[i].id;
            if(_leagueId*1 == _id*1){
              _className = 'event-fav-selected';
            }
          }
        }

        return _className;

        // let _leagueId = leagueId, _leagueList = this.myLeague, _className= '';

        // for(let i=0; i<_leagueList.length; i++){
        //   let _id = _leagueList[i].id;
        //   if(_leagueId*1 == _id*1){
        //     _className = 'event-fav-selected';
        //   }
        // }

        // return _className;

        // for(let i=0; i<_matches.length; i++){
        //   if(_follow[_matches[i]]){
        //     return 'event-fav-selected';
        //   }
        //   // if(_FootballMatch[_matches[i]].state != 4 && !_follow[_matches[i]]){
        //   //   _num2++;
        //   //   return '';
        //   // }
        //   if(_FootballMatch[_matches[i]].state == 4){
        //     _num++;

        //     if(_num == _matches.length){
        //       return 'event-fav-no';
        //     }
        //   }
        // }

        // return '';

      },

      // 比赛关注是否显示
      isFavMatchState(matchId){
        let _matchId = matchId, _FootballMatch = this.liveData.FootballMatch, _state = _FootballMatch[_matchId].state, _follow = this.follow, _unState = this.unSate, _date = this.common.dateStr(_FootballMatch[_matchId].startTime, 'YYYYMMddHHmm'), _after7day = this.after7dayFn();

        if(_unState.includes(_state) || _date >= _after7day){
          return 'event-fav-no';
        }

        if(typeof(_follow[_matchId]) == 'undefined'){
          return '';
        }

        if(_follow[_matchId]){
          return 'event-fav-selected';
        }

        return '';
      },

      // 比赛关注
      followMatch(event, state, matchId){
        event.preventDefault();
        let _state = state, _FootballMatch = this.liveData.FootballMatch, _matchId = matchId, _follow = this.follow, _unState = this.unSate, _date = this.common.dateStr(_FootballMatch[_matchId].startTime, 'YYYYMMddHHmm'), _after7day = this.after7dayFn();
        if(_unState.includes(_state) || _date >= _after7day){
          return;
        }else{
          let _param = {
            matchId: _matchId,
            operation: 1
          };

          if(_follow[_matchId]){
            _param.operation = 2;
          }

          _param.callback = (res) => {
            if(res.state == 403){ // 未登录
              this.emitObj.loginShow = true;
              this.$emit('rechangList', this.emitObj);
              this.emitObj.loginShow = false;
            }
            if(res.state == 200){
              let newObj = Object.assign({}, _follow);
              if(_param.operation == 2){
                delete newObj[_matchId];
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: this.langConfig.index[this.langConfig.curLang]['REMOVED_MY_FAVORITES'],
                  type: 'success',
                  iconClass: 'icon-font event-fav favDelIcon',
                  customClass: 'favSuccess',
                  //offset: (document.documentElement.clientHeight - 50),
                  duration: 5000
                });
              }else{
                newObj[_matchId] = true;
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: this.langConfig.index[this.langConfig.curLang]['ADD_MY_FAVORITES'],
                  type: 'success',
                  iconClass: 'icon-font icon-collectStar favSuccessIcon',
                  customClass: 'favSuccess',
                  //offset: (document.documentElement.clientHeight - 50),
                  duration: 5000
                });
              }
              this.follow = newObj;
              this.$emit('rechangList', newObj, 'follow');
            }
          };

          this.common.followMatch(_param);
        }
      },

      // 联赛关注
      followLeague(event,leagueId){
        event.preventDefault();

        let _leagueId= leagueId, _myLeague = this.myLeague, _league=this.liveData.FootballList.league;

        let _param = {
            leagueId: _leagueId,
            operation: 1
        };

        if(typeof(_myLeague) != 'undefined' && _myLeague.length > 0){
          for(let i=0; i<_myLeague.length; i++){
            let _id = _myLeague[i].id;
            if(_id*1 == _leagueId*1){
              _param.operation = 2;
            }
          }
        }

        _param.callback = (res) => {
          //console.log(res);
          if(res.state == 403){ // 未登录
            this.emitObj.loginShow = true;
            this.$emit('rechangList', this.emitObj);
            this.emitObj.loginShow = false;
          }
          if(res.state == 200){
            if(_param.operation == 2){
              for(let i=0; i<_myLeague.length; i++){
                let _id = _myLeague[i].id;
                if(_id*1 == _leagueId*1){
                  _myLeague.splice(i, 1);
                }
              }

              this.$message({
                dangerouslyUseHTMLString: true,
                message: this.langConfig.index[this.langConfig.curLang]['REMOVED_MY_LEAGUES'],
                type: 'success',
                iconClass: 'icon-font event-fav favDelIcon',
                customClass: 'favSuccess',
                //offset: (document.documentElement.clientHeight - 50),
                duration: 5000
              });
            }else{
              _myLeague.push(_league[leagueId]);

              this.$message({
                dangerouslyUseHTMLString: true,
                message: this.langConfig.index[this.langConfig.curLang]['ADD_MY_LEAGUES'],
                type: 'success',
                iconClass: 'icon-font icon-collectStar favSuccessIcon',
                customClass: 'favSuccess',
                //offset: (document.documentElement.clientHeight - 50),
                duration: 5000
              });
            }
            //console.log(_myLeague)
            this.myLeague = _myLeague;
            this.$emit('rechangList', _myLeague, 'myLeague');
          }
        };

        this.common.followLeague(_param);
      },

      // 服务器和客户端时间差
      timeDiff(){
        let _svr = new Date(this.common.jsonParse(this.svrTimestamp)*1000), _clt = new Date();
        ////console.log('服务器时间', _svr)
        this.timeGap = parseInt((_svr - _clt) / 1000 / 60);
        ////console.log('时间差', this.timeGap)
      },

      // 广告点击
      adHit(id){
        let _id = id;
        let _param = {
          id: _id
        }
        getAdHits(_param);
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },

      // 移动版半场比分、角球显示
      mobileHtCshow(key, type){
        let _data= this.liveData.FootballMatch, _key = key, _type = type, _state = _data[_key]['state'];

        if(_state == 4){ // 完成
          if(_type == 'ht'){ // 半场比分
            return true;
          }

          if(_type == 'corner'){ // 角球
            return false;
          }
        }else if(this.state2ND.includes(_state)){ // 下半场
          if(this.isItem(_key, 'homeLive') && this.isItem(_key, 'homeLive', 'corner') && this.isItem(_key, 'awayLive') && this.isItem(_key, 'awayLive', 'corner')){ //有角球数据，就显示角球
            if(_type == 'corner'){
              return true;
            }

            if(_type == 'ht'){
              return false;
            }
          }else{ // 没有角球数据就显示半场比分
            if(_type == 'corner'){
              return false;
            }

            if(_type == 'ht' && _state != 1){
              if(this.isItem(_key, 'homeLive') && this.isItem(_key, 'homeLive', 'scoreHalf') && this.isItem(_key, 'awayLive') && this.isItem(_key, 'awayLive', 'scoreHalf')){
                return true;
              }else{
                return false;
              }
            }
          }
        }
        
      },

    },

    created() {
      
    },

    beforeDestroy() {
      if(typeof window!='undefined'){
        window.removeEventListener('resize', this.handleResize);
      }
    },

    watch: {
      liveData: {
        immediate: true,
        deep: true,
        handler(val) {
          //this.oddsType = val.oddsType;
          //this.oddsForm = val.oddsForm;
          //this.FootballList = val.FootballList;
          //this.LeagueList = val.LeagueList;
          //this.oddsData = val.oddsData;
          //this.FootballMatch = val.FootballMatch;
          this.tsz = val.tsz;
          this.follow = val.follow;
          this.myLeague = val.myLeague;

          if(val.LeagueList.length == 0){
            this.startIndex = 0;
          }

          if(this.tabId != val.tabId){
            this.stateMatchNumFn();
            this.tabId = val.tabId;
          }

          if(this.watchFlag){
            this.stateMatchNumFn();
            this.svrTimestamp = val.svrTimestamp;
          }
        }
      }
    }
  }
</script>

<style lang="less">
@import '~@/style/index/soccerList.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/components/soccerList.vue